import { CalendarMonthOutlined } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import DateRangePickerExternal, { DateRangePickerProps } from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import './Calendar.css';
import { useRecoilValue } from 'recoil';
import { languageAtom } from 'atoms';
import { sxContainer, sxFieldset, sxLabel, sxLegend } from './DateRangePicker.styles';

export type ValuePiece = Date | null;

export type Value = ValuePiece | [ValuePiece, ValuePiece];

function DateRangePicker({ label, ...props }: { label?: string } & DateRangePickerProps) {
  const language = useRecoilValue(languageAtom);
  return (
    <Box sx={sxContainer}>
      {label ? (
        <>
          <Box
            component="label"
            className="MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-root MuiFormLabel-colorPrimary MuiFormLabel-filled"
            sx={sxLabel}
          >
            {label}
          </Box>
          <Box
            component="fieldset"
            aria-hidden="true"
            className="MuiOutlinedInput-notchedOutline"
            sx={sxFieldset}
          >
            <Box component="legend" sx={sxLegend}>
              <span>{label}</span>
            </Box>
          </Box>
        </>
      ) : null}
      <DateRangePickerExternal
        calendarIcon={
          <IconButton>
            <CalendarMonthOutlined />
          </IconButton>
        }
        clearIcon={null}
        locale={language}
        format="dd/MM/yy"
        calendarType="gregory"
        {...props}
      />
    </Box>
  );
}

export default DateRangePicker;
